import { getEnvConfig, isAppStage, TAppStage } from './envConfig'
import { getAppConfig } from './getAppConfig'

/**
 * determines app stage/environment and returns both common and app-specific configs for that env
 */
export const getConfig = () => {
  const appStage = getStage()
  const envConfig = getEnvConfig(appStage)
  const appConfig = getAppConfig(appStage)

  return { ...envConfig, ...appConfig, appStage }
}

// if no app stage is set or invalid value is provided, this one will be used
const defaultAppStage: TAppStage = `local`

// translates the process.env.APP_STAGE string value
// the the TAppStage value
// ! the case values in the switch hast to correspond with the string used in scripts (eg. package.json)
const getStage = (): TAppStage => {
  if (!process.env.NEXT_PUBLIC_APP_STAGE) return defaultAppStage

  const scriptParamStage = process.env.NEXT_PUBLIC_APP_STAGE

  return isAppStage(scriptParamStage) ? scriptParamStage : defaultAppStage
}
